import axios from 'axios';
import { hasFeature } from 'utils/featureFlags';
import { openAPIErrorCallback } from '../callbacks';
import { V1_MARKETPLACES, V1_PUBLIC_MARKETPLACES } from './constants';

export function getAppDetail({ id }) {
  let marketplacesUrl = V1_MARKETPLACES;
  const isCMP = hasFeature('enable-cmp-login');

  if (isCMP) {
    marketplacesUrl = V1_PUBLIC_MARKETPLACES;
  }
  return axios.get(`${marketplacesUrl}/${id}`).catch(openAPIErrorCallback);
}
